<template>
    <modal :customStyle="customStyle" @closed="close" :allowCancel="false" :contentOverflow="false">
            <div class="add-date">
                <h2 class="add-date--heading" v-if="!editData" v-text="$t('ADD_DATE_TITLE')"></h2>
                <h2 class="add-date--heading" v-if="editData" v-text="$t('EDIT_DATE_TITLE')"></h2>
                <p class="add-date--sub-heading" v-if="!editData" v-text="$t('ADD_DATE_TEXT_DESCRIPTION')"></p>
                <p class="add-date--questions" v-html="$t('SPECIAL_DATES_EVENT_NAME')"></p>
                <input
                    class="input__field add-date--input"
                    placeholder="e.g, Birthday, Anniversary etc."
                    v-model="addDate.name"/>
                <p class="input-error" v-if="showNameError">{{showNameError[0]}}</p>
                <p class="add-date--questions" v-html="$t('SPECIAL_DATES_SELECT_DATE')"></p>
                <div class="date-select">
                    <multiselect
                        class="date-select--day shop__multiselect"
                        v-model="addDate.day"
                        :options="dayOptions"
                        :show-labels="false"
                        :allow-empty="false"
                        :close-on-select="true"
                        placeholder="Day"></multiselect>
                    <multiselect
                        class="date-select--month shop__multiselect"
                        v-model="addDate.month"
                        :options="monthOptions"
                        :show-labels="false"
                        :allow-empty="false"
                        :close-on-select="true"
                        placeholder="Month"></multiselect>
                </div>
                <p class="input-error" v-if="showDateError">{{showDateError[0]}}</p>
            </div>
            <button
                slot="actions-suffix"
                :disabled="isProcessing || !hasData"
                @click="onAddDay"
                class="btn btn--green add-date-btn--add" :class="{'disabled-btn': !hasData}" >{{getSubmitButtonText}}</button>
    </modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Modal from '@/components/structure/Modal.vue';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';

export default {
    name: 'AddDateModal',
    props: {
        editData: {
            type: Object,
            require: false,
            default: null,
        },
    },
    components: {
        Modal,
        Multiselect,
    },
    data() {
        return {
            errorHandler: new ErrorResponseHandler(),
            isProcessing: false,
            addDate: {
                name: '',
                day: '',
                month: '',
            },
        };
    },
    mounted() {
        if (this.editData) {
            this.addDate.name = this.editData.name;
            this.addDate.day = this.getDay;
            this.addDate.month = this.getMonth;
        }
    },
    computed: {
        date() {
            if (this.editData) return new Date(this.editData.date);
            return new Date();
        },
        months() {
            return this.$store.getters['specialDates/getMonthOptions'];
        },
        getDay() {
            return this.date.getDate();
        },
        getMonth() {
            return this.months[this.date.getMonth()];
        },
        dayOptions() {
            return Array(31).fill().map((_, i) => (i + 1).toString());
        },
        monthOptions() {
            return this.$store.getters['specialDates/getMonthOptions'];
        },
        getSubmitButtonText() {
            if (this.isProcessing) return this.$t('SPECIAL_DATES_WAIT');
            else return this.editData ? this.$t('SPECIAL_DATES_UPDATE') : this.$t('SPECIAL_DATES_CREATE');
        },
        showNameError() {
            return this.errorHandler.response.name;
        },
        showDateError() {
            return this.errorHandler.response.date;
        },
        showTypeError() {
            return this.errorHandler.response.type_id;
        },
        customStyle() {
            return {
                'max-width': '728px',
                'max-height': '564px',
                'border-radius': '8px',
            };
        },
        hasData() {
            return this.addDate.name && this.addDate.day && this.addDate.month;
        },
    },
    methods: {
        close() {
            this.$emit('closed');
        },
        onAddDay() {
            this.isProcessing = true;
            this.addDate.date = `${this.months.indexOf(this.addDate.month) + 1}-${this.addDate.day}`;
            let response = null;
            if (this.editData) {
                this.addDate.id = this.editData.id;
                response = this.$store.dispatch('specialDates/editSpecialDate', this.addDate);
            } else {
                response = this.$store.dispatch('specialDates/addSpecialDate', this.addDate);
            }
            response.then((e) => {
                this.isProcessing = false;
                if (e.errors) this.errorHandler.setResponse(e.errors[0]);
                else {
                    this.$store.dispatch('account/fetchUserData', true);
                    this.close();
                };
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    .add-date {
        max-width: 600px;
        margin: 0 auto;
        &--heading {
            font-size: 25px;
            font-weight: 400;
            line-height: 30px;
            letter-spacing: 0em;
            text-align: left;
        }

        &--sub-heading {
            font-size: 16px;
            font-weight: 300;
            line-height: 22px;
            letter-spacing: -0.011em;
            text-align: left;
        }

        &--questions {
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            letter-spacing: 0em;
            text-align: left;
            margin-top: 24px;
        }

        &-btn {
            &--cancel, &--add {
                width: 327px;
                height: 55px;
                margin: 10px 10px;
            }
        }
        &--input {
            width: 100%;
            border: 0.5px solid lightgrey;
            padding: 10px 20px;
            color: #1a1a1a;
            font-weight: 200;
            &::placeholder {
                color: #1a1a1a;
            }
        }
    }

.date-select {
    display: flex;
    &--day, &--month, &--year {
        height: 60px;
        width: 110px;
        left: 0px;
        top: 0px;
        border-radius: 2px;
        @media (max-width: 640px) {
            margin: 0 5px;
        }
    }
    &--day{
        margin-left: 0;
    }
    &--month {
        width: 240px;
        margin: 0px;
        margin-left: 20px;
    }
}
.input-error {
    line-height: 15px;
    display: block;
    color: #b1473c;
    margin-bottom: 1.5rem;
    margin-top: 0.75rem;
    width: 100%;
    font-weight: 200;
    font-size: .75rem;
}

    @media (min-width: 768px){
        .add-date {
            max-width: 540px;
            &-btn {
                &--cancel, &--add {
                    width: 540px;
                    height: 55px;
                    margin: 10px 10px;
                }
            }
        }

        .date-select {
            &--month {
                width: 408px;
                margin: 0px;
                margin-left: 20px;
            }
        }
    }

    @media (min-width: 480px) and (max-width: 767px){
        .add-date {
            max-width: 400px;
            &-btn {
                &--cancel, &--add {
                    width: 375px;
                    height: 55px;
                    margin: 10px 10px;
                }
            }
        }

        .date-select {
            &--month {
                width: 308px;
                margin: 0px;
                margin-left: 20px;
            }
        }
    }

.disabled-btn {
    background: #F7F7F7;
    color: #CECECE;
}
</style>
